var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125.66 45.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d1d3d4;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.27,32.4c2.57,0,4.83-1.73,5.49-4.22,2.53,1.19,5.47,1.19,8,0,.56,2.09,2.27,3.69,4.39,4.11,2.13.42,4.31-.4,5.63-2.12,1.32-1.72,1.54-4.04.58-5.99-.96-1.94-2.94-3.17-5.11-3.17h-.12c.31-1.89.03-3.82-.8-5.55s-2.16-3.15-3.83-4.1c1.17-1.75,1.29-4,.3-5.85-.99-1.86-2.92-3.02-5.03-3.02s-4.04,1.16-5.03,3.02c-.99,1.86-.88,4.11.3,5.85-1.67.94-3.01,2.37-3.84,4.09-.83,1.72-1.11,3.66-.81,5.55h-.14c-3.15,0-5.69,2.55-5.69,5.69s2.55,5.69,5.69,5.69h0ZM74.15,26.7c0,.77-.46,1.46-1.17,1.75-.71.29-1.53.13-2.07-.41s-.71-1.36-.41-2.07c.29-.71.99-1.17,1.75-1.17.5,0,.99.2,1.34.56s.56.84.56,1.34h0ZM60.86,8.2c0-.77.46-1.46,1.17-1.75.71-.29,1.53-.13,2.07.41s.71,1.36.41,2.07c-.29.71-.99,1.17-1.75,1.17-1.05,0-1.9-.85-1.9-1.9h0ZM62.76,13.89c2.3,0,4.38,1.39,5.26,3.51.88,2.13.39,4.58-1.23,6.21-1.63,1.63-4.08,2.12-6.21,1.23-2.13-.88-3.51-2.96-3.51-5.26,0-3.15,2.55-5.69,5.69-5.69h0ZM53.27,24.81c.77,0,1.46.46,1.75,1.17.29.71.13,1.53-.41,2.07s-1.36.71-2.07.41c-.71-.29-1.17-.99-1.17-1.75,0-1.05.85-1.9,1.9-1.9h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 39.4,
    width: 125.66,
    height: 6.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSilver);
export default __webpack_public_path__ + "static/media/product-silver.769eee8e10e0e93aefff3b167f2ad77a.svg";
export { ForwardRef as ReactComponent };